import React, { useState } from "react";
import { get } from "lodash";
import { Container, Row, Col, Tooltip } from "reactstrap";

import { isLocal, isDev } from "../utils/env";
import { client_config } from "../utils/clientConfigs";

const style = {
  backgroundColor: "orange",
  color: "white",
};

let ENV_TEXT = null;
if (isDev()) {
  ENV_TEXT = "QA";
}
if (isLocal()) {
  ENV_TEXT = "Local";
}

const disable_header = get(client_config, "disabled_features.qa_header") || false;

export default function EnvHeader() {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  if (disable_header) {
    return null;
  }

  return (
    ENV_TEXT && (
      <Container fluid style={style}>
        <Row className="w-100" id="env-tooltip">
          <Col className="text-center">
            <h5 className="text-white pt-2">
              {ENV_TEXT} ENV
              {isLocal() && ` | ${client_config.name.toUpperCase()} Client`}
            </h5>
          </Col>
        </Row>
        <Tooltip placement="bottom" isOpen={tooltipOpen} target="env-tooltip" toggle={toggle}>
          You are currently logged into the
          <br />
          {ENV_TEXT.toUpperCase()}
          <br />
          environment where communication is restricted to whitelisted recipients
        </Tooltip>
      </Container>
    )
  );
}
